import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "CameraRoll.svg",
  "use": "CameraRoll.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"CameraRoll.svg\"><path d=\"M54.01,54.0209h-34a4,4,0,0,1-4-4v-6h-6a4,4,0,0,1-4-4v-26a4,4,0,0,1,4-4h34a4,4,0,0,1,4,4v6h6a4,4,0,0,1,4,4v26A4,4,0,0,1,54.01,54.0209Zm0-29a1,1,0,0,0-1-1h-32a1,1,0,0,0-1,1v24a1,1,0,0,0,1,1h32a1,1,0,0,0,1-1Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol